(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contextual-category-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-contextual-category-nav]');
    if (!root) return;

    const normalizePath = (value) => {
      try {
        const path = new URL(value, window.location.origin).pathname;
        return path.replace(/\/+$/, '') || '/';
      } catch (error) {
        return '';
      }
    };
    const currentPath = normalizePath(window.location.pathname);
    const context = 'shop';
    root.dataset.context = context;

    const panels = Array.from(root.querySelectorAll('[data-context-panel]'));
    panels.forEach((panel) => {
      const active = panel.dataset.contextPanel === context;
      panel.hidden = !active;
      panel.dataset.active = active ? 'true' : 'false';
    });

    const activePanel = panels.find((panel) => panel.dataset.contextPanel === context);
    const normalizeTitle = (value) => (value || '').trim().toLowerCase();
    const linkPath = (link) => normalizePath(link.dataset.navPath || link.href);
    const allNavLinks = (panel) => Array.from(panel.querySelectorAll('[data-nav-path]'));

    const resetPanelState = (panel) => {
      panel.querySelectorAll('.contextual-category-nav__item--active, .contextual-category-nav__subitem--active')
        .forEach((item) => item.classList.remove(
          'contextual-category-nav__item--active',
          'contextual-category-nav__subitem--active'
        ));
      panel.querySelectorAll('a[aria-current="page"]').forEach((link) => link.removeAttribute('aria-current'));
      panel.querySelectorAll('[data-nav-branch]').forEach((branch) => { branch.hidden = true; });
    };

    const activateNavLink = (link) => {
      if (!link) return;
      const item = link.closest('li');
      if (!item) return;

      const isSubitem = item.classList.contains('contextual-category-nav__subitem');
      item.classList.add(
        isSubitem
          ? 'contextual-category-nav__subitem--active'
          : 'contextual-category-nav__item--active'
      );
      link.setAttribute('aria-current', 'page');

      const branch = item.querySelector(':scope > [data-nav-branch]');
      if (branch) branch.hidden = false;

      if (isSubitem) {
        const parentItem = item.closest('.contextual-category-nav__sublist')?.closest('.contextual-category-nav__item');
        if (parentItem) {
          parentItem.classList.add('contextual-category-nav__item--active');
          const parentLink = parentItem.querySelector(':scope > .contextual-category-nav__link');
          const parentBranch = parentItem.querySelector(':scope > [data-nav-branch]');
          if (parentBranch) parentBranch.hidden = false;
        }
      }
    };

    if (activePanel) {
      resetPanelState(activePanel);
      const activePanelLinks = allNavLinks(activePanel);
      let currentLink = activePanelLinks.find((link) => linkPath(link) === currentPath);

      if (!currentLink) {
        const sourceLink = panels
          .filter((panel) => panel !== activePanel)
          .flatMap((panel) => allNavLinks(panel))
          .find((link) => linkPath(link) === currentPath);
        if (sourceLink) {
          const sourceTitle = normalizeTitle(sourceLink.dataset.navTitle);
          const sourceLevel = sourceLink.dataset.navLevel;
          currentLink = activePanelLinks.find((link) =>
            link.dataset.navLevel === sourceLevel
            && normalizeTitle(link.dataset.navTitle) === sourceTitle
          );
        }
      }

      activateNavLink(currentLink);
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
